export const mock = {
	tick: "CCBS1",
	fullName: "Cédula de Crédito Bancário Sapiensbank 01",
	name: "CCB sapiensbank 01",
	createdAt: String(new Date()),
	color1: "#23A6F0",
	color2: "#76CEFF",
	icon: "ccbsapiensbankPink",
	chart: [
		{ rate: 0.3, title: "Comprado", color: "#23A6F0" },
		{ rate: 0.1, title: "Reservado", color: "#616161" },
	],
	rate: 30.123,
	profitability: 18,
	min: 1000,
	deadline: 36,
	fgc: true,
	category: "CBD",
	startAt: String(new Date()),
	endAt: String(new Date()),
	recurrence: "Juros mensais",
	risk: "BBB",
  IR: 18.75,
  price: 1,
  profitabilityPure: 'R$ 4.062.500,00',
  cotas: '200.000',
  table1: [
    {
      title: "Base",
      row:  [
        {
          legend: "Exposição máxima",
          value: "R$ 1.000.000,00",
          
          content:
            "Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet.",
        },
        {
          legend: "Rentabilidade - % CDI máxima",
          value: "180 %",
          
          content:
            "Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet.",
        },
        {
          legend: "Prazo",
          value: "36 meses",
          
          content:
            "Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet.",
        },
        {
          legend: "Rentabilidade - %TIR",
          value: "50 %",
          
          content:
            "Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet.",
        },
        {
          legend: "Múltiplo",
          value: "1.5 x",
          
          content:
            "Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet.",
        },
      ],
    },
     {
      title: "Otimista",
      row:  [
        {
          legend: "Exposição máxima",
          value: "R$ 1.000.000,00",
          
          content:
            "Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet.",
        },
        {
          legend: "Rentabilidade - % CDI máxima",
          value: "180 %",
          
          content:
            "Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet.",
        },
        {
          legend: "Prazo",
          value: "36 meses",
          
          content:
            "Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet.",
        },
        {
          legend: "Rentabilidade - %TIR",
          value: "50 %",
          
          content:
            "Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet.",
        },
        {
          legend: "Múltiplo",
          value: "1.5 x",
          
          content:
            "Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet.",
        },
      ],
    },
    {
      title: "Pessimista",
      row:  [
        {
          legend: "Exposição máxima",
          value: "R$ 1.000.000,00",
          
          content:
            "Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet.",
        },
        {
          legend: "Rentabilidade - % CDI máxima",
          value: "180 %",
          
          content:
            "Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet.",
        },
        {
          legend: "Prazo",
          value: "36 meses",
          
          content:
            "Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet.",
        },
        {
          legend: "Rentabilidade - %TIR",
          value: "50 %",
          
          content:
            "Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet.",
        },
        {
          legend: "Múltiplo",
          value: "1.5 x",
          
          content:
            "Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet.",
        },
      ],
    }
  ],
	table3Half1: [
		{
			legend: "Tipo de investimento",
			value: "Certificado de Depósito Bancário",
			
			content:
				"Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet.",
		},
		{
			legend: "Data de resgate",
			value: "24/04/2024 (358 dias)",
			
			content:
				"Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet.",
		},
		{
			legend: "Rentabilidade bruta ao ano",
			value: "15,46% a.a.",
			
			content:
				"Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet.",
		},
		{
			legend: "Rentabilidade bruta do CDI",
			value: "133,66% do CDI",
			
			content:
				"Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet.",
		},
    {
			legend: "Rentabilidade líquida ao ano",
			value: "12,36% a.a.",
			
			content:
				"Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet.",
		},
		{
			legend: "Rentabilidade líquida do CDI",
			value: "106,89% do CDI",
			
			content:
				"Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet.",
		},
		{
			legend: "Taxa do DI futuro (ao ano)",
			value: "106,89% do CDI",
			
			content:
				"Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet.",
		},
    {
			legend: "% de Lucro acima da Poupança",
			value: "71,18%",
			
			content:
				"Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet.",
		},
	],
	table3Half2: [
		{
			legend: "Investimento mínimo",
			value: "R$ 1.127,53",
			
			content:
				"Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet.",
		},
		{
			legend: "Liquidez",
			value: "No vencimento",
			
			content:
				"Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet.",
		},
		{
			legend: "Tipo",
			value: "Prefixado",
			
			content:
				"Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet.",
		},
		{
			legend: "Garantia do FGC",
			value: "Até R$ 250.000,00",
			
			content:
				"Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet.",
		},
    {
			legend: "Selo CETIP Certifica",
			value: "Não",
			
			content:
				"Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet.",
		},
		{
			legend: "Emissor",
			value: "Banco X",
			
			content:
				"Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet.",
		},
		{
			legend: "Índice de Basiléia",
			value: "Não informado",
			
			content:
				"Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet.",
		},
    {
			legend: "Corretora/distribuidor(a)",
			value: "Add",
			
			content:
				"Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet.",
		},
	],
	table2: [
		{
			legend: "Certificado de Depósito Bancário",
			value: "FGC",
			
			content:
				"Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet.",
		},
		{
			legend: "Patrimônio da empresa",
			value: "Ativos",
			
			content:
				"Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet.",
		},
		{
			legend: "Patrimônio dos sócios",
			value: "Aval",
			
			content:
				"Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet. Lorem ipsum dolor sit amet.",
		},
	],
  table3: [
      {
        icon: "handshake1White",
        value: "Liquidação",
        content: "Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet a. Facilisis at ornare enim congue tristique.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet a. Facilisis at ornare enim congue tristique."
      },
      {
        icon: "contract%White",
        value: "Tributação",
        content: "Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet a. Facilisis at ornare enim congue tristique.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet a. Facilisis at ornare enim congue tristique."
      },
      {
        icon: "scaleWhite",
        value: "Legislação e Regulamento",
        content: "Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet a. Facilisis at ornare enim congue tristique.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet a. Facilisis at ornare enim congue tristique."
      },
      {
        icon: "beehivesWhite",
        value: "Composição",
        content: "Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet a. Facilisis at ornare enim congue tristique.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet a. Facilisis at ornare enim congue tristique."
      },
      {
        icon: "worWhiteld$",
        value: "Cenário Macro Econômico",
        content: "Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet a. Facilisis at ornare enim congue tristique.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet a. Facilisis at ornare enim congue tristique."
      },
      {
        icon: "shield$White",
        value: "Risco Operacional",
        content: "Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet a. Facilisis at ornare enim congue tristique.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet a. Facilisis at ornare enim congue tristique."
      },
      {
        icon: "arrowStonksWhite",
        value: "Risco Projetado",
        content: "Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet a. Facilisis at ornare enim congue tristique.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet a. Facilisis at ornare enim congue tristique."
      },
      {
        icon: "cicle$White",
        value: "Fluxo de Operação",
        content: "Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet a. Facilisis at ornare enim congue tristique.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet a. Facilisis at ornare enim congue tristique."
      },
      {
        icon: "dbWhite",
        value: "Fluxo de Recebimento",
        content: "Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet a. Facilisis at ornare enim congue tristique.Lorem ipsum dolor sit amet consectetur. Mauris ipsum turpis tristique amet a. Facilisis at ornare enim congue tristique."
      },
    ],
  similarCards: [{
    icon:"OETokenBasic", 
    tick:"CCBS1",
    min:1000,
    color:"#CB6BE6",
    lastPrice: 1,
    circulating: 10000,
    variation: 1.5,
    profitability: 12,
    name: 'CCB sapiensbank 1',
    index: null,
    rate: 20,
    recurrence: 'm',
    deadline: 20,
    fgc: true,
    category: 'CBD'
  },
  {
    icon:"OETokenBasic", 
    tick:"CCBS1",
    min:1000,
    color:"#CB6BE6",
    lastPrice: 1,
    circulating: 10000,
    variation: 1.5,
    profitability: 12,
    name: 'CCB sapiensbank 1',
    index: null,
    rate: 20,
    recurrence: 'm',
    deadline: 20,
    fgc: true,
    category: 'CBD'
  },
  {
    icon:"OETokenBasic", 
    tick:"CCBS1",
    min:1000,
    color:"#CB6BE6",
    lastPrice: 1,
    circulating: 10000,
    variation: 1.5,
    profitability: 12,
    name: 'CCB sapiensbank 1',
    index: null,
    rate: 20,
    recurrence: 'm',
    deadline: 20,
    fgc: true,
    category: 'CBD'
  },
  {
    icon:"OETokenBasic", 
    tick:"CCBS1",
    min:1000,
    color:"#CB6BE6",
    lastPrice: 1,
    circulating: 10000,
    variation: 1.5,
    profitability: 12,
    name: 'CCB sapiensbank 1',
    index: null,
    rate: 20,
    recurrence: 'm',
    deadline: 20,
    fgc: true,
    category: 'CBD'
  }],

  iconTickInverted: 'ccbsapiensbankPinkInverted',
  iconLeaf: 'iconLeafPink',
  iconLeafInverted: 'iconLeafPinkInverted',
  handleSlider:'handleSliderBlack',

  freeResponsibility: 'Somos especialistas em tokenização de ativos alternativos. Por meio de tecnologia proprietária, originamos, estruturamos e distribuímos ativos tokenizados de forma direta. Não somos e não atuamos como instituição financeira ou administrador de carteira de valores mobiliários. Não atuamos como advogado de nossos clientes. Os websites (“Site”), www.sapiensbank.com.br e www.aluguelverde.com, é operado por Sapiensbank Pagamentos S.A (“Sapiensbank”), empresa especializada na originação, estruturação e distribuição de ativos tokenizados que não se enquadrem como valores mobiliários, nos termos da Lei nº 6.385/76. Leia sempre com atenção as informações essenciais sobre as operações, em especial a seção de alertas sobre risco. Somos especialistas em tokenização de ativos alternativos. Por meio de tecnologia proprietária, originamos, estruturamos e distribuímos ativos tokenizados de forma direta. Não somos e não atuamos como instituição financeira ou administrador de carteira de valores mobiliários. Não atuamos como advogado de nossos clientes. Os websites (“Site”), www.sapiensbank.com.br e www.aluguelverde.com, é operado por Sapiensbank Pagamentos S.A (“Sapiensbank”), empresa especializada na originação, estruturação e distribuição de ativos tokenizados que não se enquadrem como valores mobiliários, nos termos da Lei nº 6.385/76. Leia sempre com atenção as informações essenciais sobre as operações, em especial a seção de alertas sobre risco. Somos especialistas em tokenização de ativos alternativos. Por meio de tecnologia proprietária, originamos, estruturamos e distribuímos ativos tokenizados de forma direta. Não somos e não atuamos como instituição financeira ou administrador de carteira de valores mobiliários. Não atuamos como advogado de nossos clientes. Os websites (“Site”), www.sapiensbank.com.br e www.aluguelverde.com, é operado por Sapiensbank Pagamentos S.A (“Sapiensbank”), empresa especializada na originação, estruturação e distribuição de ativos tokenizados que não se enquadrem como valores mobiliários, nos termos da Lei nº 6.385/76. Leia sempre com atenção as informações essenciais sobre as operações, em especial a seção de alertas sobre risco.'
};
